// utils/get-icon-from-type.ts (or wherever it lives)
import { isClinicStore, isVendingMachine } from './define-store-types';
import markerClinicIcon from '../../assets/images/map-markers/clinic.png';
import markerOpticsIcon from '../../assets/images/map-markers/optic.png';
import markerVendingIcon from '../../assets/images/map-markers/vending.png';
import {
  MARKER_WIDTH,
  MARKER_HEIGHT,
  MARKER_WIDTH_ACTIVE,
  MARKER_HEIGHT_ACTIVE,
} from '../../constants/ecp-locator';

export const getMarkerIcon = (
  type: string,
  code?: string,
  codeToCheck?: string,
) => {
  const isActive = codeToCheck === code;

  let url: string;
  switch (true) {
    case isClinicStore(type):
      url = markerClinicIcon;
      break;
    case isVendingMachine(type):
      url = markerVendingIcon;
      break;
    default:
      url = markerOpticsIcon;
      break;
  }

  const width  = isActive ? MARKER_WIDTH_ACTIVE  : MARKER_WIDTH;
  const height = isActive ? MARKER_HEIGHT_ACTIVE : MARKER_HEIGHT;

  return { url, width, height };
};
